import Icon from '../components/Icon.vue'

Icon.register({
  'closed-captioning': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 64c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h416zM218.1 287.7c-41.2 37.9-92.2 15.4-92.3-32.6 0-46.1 53.8-63.2 94.6-31.2 2.9 2.3 7.2 1.4 9.1-1.7l17.5-30.5c1.5-2.5 1.1-3.7-1-5.7-50.8-49.4-172.5-27.2-172.5 70.1 0 100 119.2 124.7 172.8 67.9 2-2.1 2.2-5.3 0.5-7.7l-19.5-27.7c-2.1-3-6.4-3.4-9.2-0.9zM408.5 287.7c-41.2 37.9-92.2 15.4-92.2-32.6 0-46.1 53.8-63.2 94.6-31.2 2.9 2.3 7.2 1.4 9.1-1.7l17.5-30.5c1.5-2.5 1.1-3.7-1-5.7-50.8-49.4-172.5-27.2-172.5 70.1 0 100 119.2 124.8 172.7 67.9 2-2.1 2.2-5.3 0.5-7.7l-19.5-27.7c-2.1-3-6.4-3.4-9.2-0.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/closed-captioning.js
// module id = 1204
// module chunks = 0